import React from "react";
import { Box, Text, Flex, Icon, Divider, VStack } from "@chakra-ui/react";
import { BiTrendingUp, BiTrendingDown } from "react-icons/bi";
import moment from "moment";
import { formatMoney } from "../../services/utils/helpersFunc";
import SectionLayout from "./SectionLayout";
import { motion } from "framer-motion";

const MotionFlex = motion(Flex);

const TransactionItem = ({ transaction }) => {
  const isCredit = transaction.type === "credit";
  
  return (
    <MotionFlex
      align="center"
      p="3"
      borderRadius="lg"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ bg: "gray.50" }}
      transition={{ duration: 0.3 }}
    >
      <Flex
        w="40px"
        h="40px"
        borderRadius="full"
        bg={isCredit ? "green.50" : "red.50"}
        align="center"
        justify="center"
        mr="4"
      >
        <Icon
          as={isCredit ? BiTrendingDown : BiTrendingUp}
          w={6}
          h={6}
          color={isCredit ? "green.500" : "red.500"}
        />
      </Flex>
      
      <Box flex="1">
        <Text fontWeight="600" fontSize="14px" color="text.primary">
          {transaction?.narration}
        </Text>
        <Text fontSize="12px" color="text.secondary">
          Ref: {transaction?.reference} • {moment(transaction.created_at).format("DD MMM YYYY, h:mm a")}
        </Text>
      </Box>
      
      <Box textAlign="right">
        <Text
          fontWeight="700"
          fontSize="15px"
          color={isCredit ? "green.600" : "red.600"}
        >
          {isCredit ? "+" : "-"}₦{formatMoney(transaction?.amount)}
        </Text>
        <Text fontSize="10px" color="text.muted" textTransform="uppercase">
          {transaction?.tag}
        </Text>
      </Box>
    </MotionFlex>
  );
};

const TransactionLog = ({ loanRequest }) => {
  const transactions = loanRequest?.transactions || [];

  return (
    <SectionLayout
      title="Transaction History"
      gridProps={{ columns: 1, spacing: 1 }}
    >
      {transactions.length > 0 ? (
        <VStack align="stretch" spacing={2} divider={<Divider />}>
          {transactions.map((transaction, index) => (
            <TransactionItem key={index} transaction={transaction} />
          ))}
        </VStack>
      ) : (
        <Flex justify="center" py="8">
          <Text color="text.muted" fontSize="14px">
            No transaction history available
          </Text>
        </Flex>
      )}
    </SectionLayout>
  );
};

export default TransactionLog;
